var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-currency-field', {
    staticClass: "text-right",
    attrs: {
      "label": `최소연령`,
      "outlined": "",
      "prefix": "만",
      "suffix": "세"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.age.value__min,
      callback: function ($$v) {
        _vm.$set(_vm.form.age, "value__min", $$v);
      },
      expression: "form.age.value__min"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-currency-field', {
    staticClass: "text-right",
    attrs: {
      "label": `최대연령`,
      "outlined": "",
      "prefix": "만",
      "suffix": "세"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.age.value__max,
      callback: function ($$v) {
        _vm.$set(_vm.form.age, "value__max", $$v);
      },
      expression: "form.age.value__max"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "연령무관",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.age.isIrrelevant,
      callback: function ($$v) {
        _vm.$set(_vm.form.age, "isIrrelevant", $$v);
      },
      expression: "form.age.isIrrelevant"
    }
  })], 1), _c('v-col', {
    staticClass: "mt-lg-n14",
    attrs: {
      "cols": "12"
    }
  }, [_c('discrimination-dialog-age', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-n12",
          attrs: {
            "small": "",
            "text": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" ※ 연령차별금지 / 고용상 연령차별 금지에 관한 법률 ")])];
      }
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }